// Round avatar with initials, coloured per member.
import type { TeamMemberSummary } from "../../../../../../shared/types/production-schedule";

interface Props {
  member: TeamMemberSummary | null;
  size?: number;
  showName?: boolean;
}

export function AssigneeChip({ member, size = 26, showName = false }: Props) {
  if (!member) {
    return <span style={{ color: "var(--bsp-fg-subtle)" }}>—</span>;
  }
  const avatar = (
    <div
      className="proj-avatar"
      style={{
        width: size,
        height: size,
        fontSize: Math.max(9, Math.round(size * 0.38)),
        background: member.color,
      }}
      title={member.name}
    >
      {member.initials}
    </div>
  );
  if (!showName) return avatar;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      {avatar}
      <span style={{ fontSize: 12 }}>{member.name}</span>
    </div>
  );
}
